/* ═══════════════════════════════════════════════════════════
   Media Gallery — 4 display modes, hover zoom, lightbox modal
   Lightbox: global event delegation — aucun timing issue
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ─────────────────────────────────────────
     LIGHTBOX MANAGER
     ───────────────────────────────────────── */
  var Lightbox = {
    el:      null,
    imgEl:   null,
    ctrEl:   null,
    sources: [],
    current: 0,
    ready:   false,

    init: function () {
      var lb = document.getElementById('media-lightbox');
      if (!lb || this.ready) return;
      this.el    = lb;
      this.imgEl = lb.querySelector('[data-lightbox-image]');
      this.ctrEl = lb.querySelector('[data-lightbox-counter]');
      this.ready = true;

      var self = this;

      /* Délégation interne : fermer / naviguer */
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) { self.close(); return; }
        if (e.target.closest('[data-lightbox-prev]'))  { self.navigate(-1); return; }
        if (e.target.closest('[data-lightbox-next]'))  { self.navigate(1);  return; }
        /* clic sur le backdrop lui-même */
        if (e.target === lb || e.target.classList.contains('media-lightbox__backdrop')) {
          self.close();
        }
      });

      lb.addEventListener('keydown', function (e) {
        if (e.key === 'Escape')     { e.preventDefault(); self.close(); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); self.navigate(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); self.navigate(1); }
      });

      var tx = 0;
      lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend',   function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) self.navigate(dx < 0 ? 1 : -1);
      });
    },

    open: function (srcs, idx) {
      if (!this.ready) this.init();
      if (!this.ready) return;
      this._triggerEl = document.activeElement;
      this.sources = Array.isArray(srcs) ? srcs : [];
      this.current = (typeof idx === 'number' && idx >= 0 && idx < this.sources.length) ? idx : 0;
      this._render();
      this.el.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      this.el.setAttribute('tabindex', '-1');
      this.el.focus();

      if (!this._tabHandler) {
        this._tabHandler = this._onTab.bind(this);
        this.el.addEventListener('keydown', this._tabHandler);
      }
    },

    close: function () {
      if (!this.el) return;
      this.el.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (this._triggerEl && typeof this._triggerEl.focus === 'function') {
        this._triggerEl.focus();
      }
    },

    _onTab: function (e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.from(this.el.querySelectorAll(
        'button:not([disabled]), [tabindex]:not([tabindex="-1"]), a[href]'
      )).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusable.length) { e.preventDefault(); return; }
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first || document.activeElement === this.el) {
          e.preventDefault(); last.focus();
        }
      } else {
        if (document.activeElement === last || document.activeElement === this.el) {
          e.preventDefault(); first.focus();
        }
      }
    },

    navigate: function (dir) {
      if (!this.sources.length) return;
      this.current = (this.current + dir + this.sources.length) % this.sources.length;
      this._render();
    },

    _render: function () {
      var s = this.sources[this.current];
      if (!s || !this.imgEl) return;
      this.imgEl.src = s.src;
      this.imgEl.alt = s.alt || '';
      if (this.ctrEl) {
        this.ctrEl.textContent = this.sources.length > 1
          ? (this.current + 1) + ' / ' + this.sources.length
          : '';
      }
      var multi = this.sources.length > 1;
      var prev = this.el.querySelector('[data-lightbox-prev]');
      var next = this.el.querySelector('[data-lightbox-next]');
      if (prev) prev.hidden = !multi;
      if (next) next.hidden = !multi;
    }
  };

  /* ─────────────────────────────────────────
     Collect zoom sources from a gallery root
     ───────────────────────────────────────── */
  function collectSources(root) {
    var srcs = [];
    root.querySelectorAll('[data-zoom-trigger]').forEach(function (el) {
      if (el.dataset.zoomSrc) {
        srcs.push({ src: el.dataset.zoomSrc, alt: el.dataset.zoomAlt || '' });
      }
    });
    return srcs;
  }

  /* ─────────────────────────────────────────
     GLOBAL EVENT DELEGATION — lightbox triggers
     Un seul listener sur document : zéro timing issue,
     fonctionne quelle que soit la méthode de rendu.
     ───────────────────────────────────────── */
  function openFromTrigger(e) {
    var trigger = e.target.closest('[data-zoom-trigger]');
    if (!trigger) return;
    e.preventDefault();

    var gallery = trigger.closest('[data-media-gallery]');
    var srcs = gallery ? collectSources(gallery) : [];

    /* fallback si collectSources ne trouve rien */
    if (!srcs.length && trigger.dataset.zoomSrc) {
      srcs = [{ src: trigger.dataset.zoomSrc, alt: trigger.dataset.zoomAlt || '' }];
    }

    var src = trigger.dataset.zoomSrc;
    var idx = srcs.findIndex(function (s) { return s.src === src; });
    Lightbox.open(srcs, idx >= 0 ? idx : 0);
  }

  document.addEventListener('click', openFromTrigger);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') openFromTrigger(e);
  });

  /* ─────────────────────────────────────────
     HOVER ZOOM (loupe follow-cursor)
     ───────────────────────────────────────── */
  function initHoverZoom(wrap) {
    var img = wrap.querySelector('.media-gallery__image');
    if (!img) return;
    wrap.addEventListener('mouseenter', function () { wrap.classList.add('is-zooming'); });
    wrap.addEventListener('mousemove',  function (e) {
      var r  = wrap.getBoundingClientRect();
      var xp = ((e.clientX - r.left) / r.width  * 100).toFixed(1);
      var yp = ((e.clientY - r.top)  / r.height * 100).toFixed(1);
      img.style.transformOrigin = xp + '% ' + yp + '%';
    });
    wrap.addEventListener('mouseleave', function () {
      wrap.classList.remove('is-zooming');
      img.style.transformOrigin = 'center center';
    });
  }

  /* ─────────────────────────────────────────
     <media-gallery> CUSTOM ELEMENT
     Gère thumbs-side / thumbs-bottom / stacked
     Le lightbox est géré globalement ci-dessus.
     ───────────────────────────────────────── */
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides    = Array.from(this.querySelectorAll('[data-media-id]'));
        this.thumbBtns = Array.from(this.querySelectorAll('[data-thumb-id]'));
        this.dots      = Array.from(this.querySelectorAll('.media-gallery__dot'));
        this.activeIdx = 0;
        this.zoomMode  = this.dataset.zoomMode || 'both';

        this.variantMap = {};
        try {
          var mapEl = this.querySelector('[data-variant-media-json]');
          if (mapEl) this.variantMap = JSON.parse(mapEl.textContent);
        } catch (_) {}

        this._bindThumbs();
        this._bindArrows();
        this._bindTouch();
        this._bindKeyboard();
        this._initHover();
        this._subscribeVariant();
      }

      disconnectedCallback() {
        if (this._unsubVariant) this._unsubVariant();
      }

      goTo(idx) {
        var len = this.slides.length;
        if (len === 0) return;
        idx = ((idx % len) + len) % len;
        this.slides.forEach(function (s, i) {
          s.hidden = i !== idx;
          s.classList.toggle('is-active', i === idx);
        });
        this.thumbBtns.forEach(function (t, i) {
          t.classList.toggle('is-active', i === idx);
          t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          t.tabIndex = i === idx ? 0 : -1;
        });
        this.dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
        this.activeIdx = idx;
      }

      _bindThumbs() {
        var self = this;
        this.thumbBtns.forEach(function (btn, i) {
          btn.addEventListener('click', function () { self.goTo(i); });
        });
      }

      _bindArrows() {
        var self = this;
        var prev = this.querySelector('[data-gallery-prev]');
        var next = this.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { self.goTo(self.activeIdx - 1); });
        if (next) next.addEventListener('click', function () { self.goTo(self.activeIdx + 1); });
      }

      _bindTouch() {
        var self = this;
        var tx   = 0;
        var main = this.querySelector('[data-gallery-main]');
        if (!main) return;
        main.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
        main.addEventListener('touchend',   function (e) {
          var dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 40) self.goTo(self.activeIdx + (dx < 0 ? 1 : -1));
        });
      }

      _bindKeyboard() {
        var self = this;
        this.addEventListener('keydown', function (e) {
          if (e.target.closest('#media-lightbox')) return;
          if (e.key === 'ArrowLeft')  { e.preventDefault(); self.goTo(self.activeIdx - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.activeIdx + 1); }
        });
      }

      _initHover() {
        var mode = this.zoomMode;
        if (mode === 'hover' || mode === 'both') {
          this.querySelectorAll('.js-zoom-hover').forEach(initHoverZoom);
        }
      }

      _subscribeVariant() {
        if (!window.pubsub) return;
        var self = this;
        this._unsubVariant = window.pubsub.subscribe('variant:changed', function (data) {
          if (!data) return;
          var mediaId = self.variantMap[data.variantId];
          if (!mediaId) return;
          var idx = self.slides.findIndex(function (s) {
            return parseInt(s.dataset.mediaId, 10) === parseInt(mediaId, 10);
          });
          if (idx >= 0) self.goTo(idx);
        });
      }
    });
  }

  /* ─────────────────────────────────────────
     MODE GRID — hover zoom + mobile slider (scroll-snap + scrollbar)
     (la modale est gérée par la délégation globale)
     ───────────────────────────────────────── */
  function initGridGallery(el) {
    var mode = el.dataset.zoomMode || 'both';
    if (mode === 'hover' || mode === 'both') {
      el.querySelectorAll('.js-zoom-hover').forEach(initHoverZoom);
    }
  }

  /* ─────────────────────────────────────────
     MODE STACK-RAIL — pile d'images dans le flux + rail de vignettes
     Le rail navigue dans la pile ; la vignette active suit le scroll.
     (la modale est gérée par la délégation globale)
     ───────────────────────────────────────── */
  function initStackRail(root) {
    var mode = root.dataset.zoomMode || 'both';
    if (mode === 'hover' || mode === 'both') {
      root.querySelectorAll('.js-zoom-hover').forEach(initHoverZoom);
    }

    var items  = Array.from(root.querySelectorAll('[data-stack-item]'));
    var thumbs = Array.from(root.querySelectorAll('[data-rail-index]'));
    var track  = root.querySelector('[data-rail-track]');
    if (items.length < 2 || !thumbs.length) return;

    function headerOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      return parseInt(raw, 10) || 64;
    }

    function scrollToItem(item) {
      /* En carrousel mobile, la pile scrolle horizontalement : on reste dans le cadre. */
      var stack = item.parentElement;
      if (stack && stack.scrollWidth > stack.clientWidth + 1) {
        stack.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        return;
      }
      var top = item.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function setActive(idx) {
      thumbs.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      /* Garde la vignette active dans le cadre du rail sans bouger la page */
      var active = thumbs[idx];
      if (active && track && track.scrollHeight > track.clientHeight + 1) {
        var aTop = active.offsetTop;
        var aBot = aTop + active.offsetHeight;
        if (aTop < track.scrollTop) {
          track.scrollTop = aTop - 8;
        } else if (aBot > track.scrollTop + track.clientHeight) {
          track.scrollTop = aBot - track.clientHeight + 8;
        }
      }
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = items[parseInt(btn.dataset.railIndex, 10)];
        if (item) scrollToItem(item);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(items.indexOf(entry.target));
        });
      }, { threshold: 0.55 });
      items.forEach(function (item) { observer.observe(item); });
    }

    /* Changement de variante : on ne déplace la page que si le visuel de la variante
       est entièrement hors écran, pour ne pas faire sauter la page à chaque clic
       sur une taille (qui partage souvent le même visuel que la couleur courante). */
    if (!window.pubsub) return;
    var variantMap = {};
    try {
      var mapEl = root.querySelector('[data-variant-media-json]');
      if (mapEl) variantMap = JSON.parse(mapEl.textContent);
    } catch (_) {}

    window.pubsub.subscribe('variant:changed', function (data) {
      if (!data) return;
      var mediaId = variantMap[data.variantId];
      if (!mediaId) return;
      var item = items.find(function (el) {
        return parseInt(el.dataset.mediaId, 10) === parseInt(mediaId, 10);
      });
      if (!item) return;
      var rect = item.getBoundingClientRect();
      var visible = rect.bottom > headerOffset() && rect.top < window.innerHeight;
      if (!visible) scrollToItem(item);
    });
  }

  /* ─────────────────────────────────────────
     INIT
     ───────────────────────────────────────── */
  function init() {
    Lightbox.init();
    document.querySelectorAll('.media-gallery--grid[data-media-gallery]').forEach(initGridGallery);
    document.querySelectorAll('[data-stack-rail]').forEach(initStackRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
